// extracted by mini-css-extract-plugin
export default {"creditCard":"EK-z","expired":"FK-z"};